import { useEffect } from 'react';
import { Route, Routes } from 'react-router';
import { Main, Landing, Steps, Upload, Results, VerifyEmail, VerifyOtp } from './views';
import { MainLayout, TestStripLayout } from './components/Layouts'
import { ErrorProvider } from './context/ErrorContext';
import { ErrorModal } from './components/Modals';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { useError } from './context/ErrorContext';
import { initializeErrorHandler } from './store/middleware/errorMiddleware';
import { CustomSnackbar } from './components/CustomSnackbar';
import { UploadManual } from './views/TestStrip/UploadManual/UploadManual';
import ReactGA from 'react-ga4'
const TRACKING_ID = !process.env.REACT_APP_GTAG_TRACKING_ID  ? '__GTAG_TRACKING_ID__' : process.env.REACT_APP_GTAG_TRACKING_ID;

ReactGA.initialize(TRACKING_ID)

const ErrorHandler = () => {
  const { setError } = useError();
  

  useEffect(() => {
    initializeErrorHandler(setError);
  }, [setError]);

  return null;
};
const mw = async(context, next)=>{
  console.log("middleware")
  return await next();
}
function App() {

  return (
    <ErrorProvider>
      <ErrorBoundary>
        <ErrorHandler />
        <CustomSnackbar />

        <Routes>
          <Route path="/" element={<MainLayout/>}>
            <Route index element={<Main/>}  />
          </Route>
          <Route path="/test-strip" element={<TestStripLayout/>}>
            <Route index element={<Landing/>} />
            <Route path="steps" element={<Steps/>} />
            <Route path="upload" element={<Upload/>} />
            <Route path="upload-manual" element={<UploadManual/>} />
            <Route path="results" element={<Results/>} />
            <Route path="verify-email" element={<VerifyEmail/>} />
            <Route path="verify-otp" element={<VerifyOtp/>} />
          </Route>
        </Routes>
        <ErrorModal />
      </ErrorBoundary>
    </ErrorProvider>
  );
}

export default App;
